module.exports = __webpack_public_path__ + "static/media/time-clock-circle.67aa57e4.svg";